export function getDegreeTypes() {
  return [
    "Associate's Degree",
    "Bachelor's Degree",
    "Doctoral Degree",
    "First Professional Degree",
    "Graduate/Professional Certificate",
    "Master's Degree",
    "Post-baccalaureate Certificate",
    "Undergraduate Certificate or Diploma",
  ];
}
